var render, staticRenderFns
import script from "./CrtLeftSideBar.vue?vue&type=script&lang=js&"
export * from "./CrtLeftSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4234fd0f')) {
      api.createRecord('4234fd0f', component.options)
    } else {
      api.reload('4234fd0f', component.options)
    }
    
  }
}
component.options.__file = "src/components/layout/LeftSideBar/CrtLeftSideBar.vue"
export default component.exports